export enum ProductBadgeType {
  // 품절
  SOLD_OUT = 'SOLD_OUT',

  // 한정
  LIMITED = 'LIMITED',

  // 수량 한정
  QUANTITY_LIMITED = 'QUANTITY_LIMITED',

  // 기간 한정
  PERIOD_LIMITED = 'PERIOD_LIMITED',

  // 출시 예정
  UPCOMING = 'UPCOMING',

  // 랭킹
  RANKING = 'RANKING',

  // nft
  NFT = 'NFT',

  // 멤버십
  MEMBERSHIP = 'MEMBERSHIP',

  // 인기
  POPULAR = 'POPULAR',

  // 급상승
  TRENDING = 'TRENDING',

  // 브랜드딜
  BRAND_DEAL = 'BRAND_DEAL',

  // 펀딩
  FUNDING = 'FUNDING',

  // 종료
  CLOSED = 'CLOSED',
}

export enum ProductBadgeSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  xLarge = 'xLarge',
}
